import { render, staticRenderFns } from "./VIPclass.vue?vue&type=template&id=38006bfa&scoped=true"
import script from "./VIPclass.vue?vue&type=script&lang=js"
export * from "./VIPclass.vue?vue&type=script&lang=js"
import style0 from "./VIPclass.vue?vue&type=style&index=0&id=38006bfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38006bfa",
  null
  
)

export default component.exports